import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import Layout from '../../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tag, ArrowLeft, Plus, Edit, Trash2, ToggleLeft, ToggleRight } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Badge } from '../../components/ui/badge';
import PlanManagement from '../../components/admin/PlanManagement';
import CouponManagement from '../../components/admin/CouponManagement';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FinancePlansPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('plans');

  return (
    <Layout>
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/finances')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Finances
        </Button>
        
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Tag className="w-8 h-8" />
          Plans & Subscriptions
        </h1>
        <p className="text-gray-600 mt-2">Manage pricing plans and discount coupons</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 max-w-[600px]">
          <TabsTrigger value="plans" className="flex items-center gap-2">
            <Tag size={18} />
            Pricing Plans
          </TabsTrigger>
          <TabsTrigger value="coupons" className="flex items-center gap-2">
            <Tag size={18} />
            Coupons
          </TabsTrigger>
        </TabsList>

        <TabsContent value="plans" className="mt-6">
          <PlanManagement />
        </TabsContent>

        <TabsContent value="coupons" className="mt-6">
          <CouponManagement />
        </TabsContent>
      </Tabs>
    </div>
    </Layout>
  );
};

export default FinancePlansPage;
